export default (values) => {
  const errors = {};

  if (!values?.username) errors.username = true;

  return errors;
};
